import { FC } from "react";
import { ColSize, ContentSection, InputForm, RowSize } from "../../../../../../../shared/components";
import { IntermediaryInformation } from "../../../../../../../shared/interfaces/services/get-producer-information-service";
import dayjs from "dayjs";

interface PersonalInfoFormProperties {
    intermediaryInformation: IntermediaryInformation;
}

export const PersonalInfoForm: FC<PersonalInfoFormProperties> = ({intermediaryInformation}) => {
    const {
        nombre,
        fechaNac,
        tipoDocumento,
        nroDocumento,
        nroDeIibb,
        nroMatricula,
        nroDeCuit,
    } = intermediaryInformation;
    
    const formItems: { label: string; name: string; size: 75 | 25; initialValue?: string }[] = [
        { label: "Apellido y Nombre", name: "fullName", size: 75, initialValue: nombre },
        { label: "Fecha de Nacimiento", name: "birthday", size: 25, initialValue: dayjs(fechaNac).format('DD/MM/YYYY')},
        { label: "Tipo de Documento", name: "documentType", size: 25, initialValue: tipoDocumento},
        { label: "Número de Documento", name: "documentNumber", size: 25, initialValue: nroDocumento},
        { label: "CUIT", name: "cuit", size: 25, initialValue: nroDeCuit},
        { label: "Número de IIBB", name: "iibbNumber", size: 25, initialValue: nroDeIibb},
        { label: "Número de Matrícula", name: "registrationNumber", size: 25, initialValue: nroMatricula},
      ];
      

    return (
        <div id="datos-personales">
            <ContentSection level="h3" title="Datos Personales">
                <RowSize>
                    {formItems.map(({ label, name, size, initialValue }) => (
                        <ColSize key={name} size={size}>
                            <InputForm
                                formProps={{
                                    label: label,
                                    name: name,
                                    initialValue: initialValue
                                }}
                                inputProps={{ placeholder: label, disabled: true }}
                            />
                        </ColSize>
                    ))}
                </RowSize>
            </ContentSection>
        </div>
    )
}
